import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import Swal from "sweetalert2";

export default function Categoria() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { get, post, put } = useFetch();
    const location = useLocation();

    const [state, setState] = useState({
        acao: location.state?.acao || (id === "criar" ? "Criar" : "Visualizar"),
        dados: { nome_categoria: "", descricao: "" }
    });

    useEffect(() => {
        if (id !== "criar") {
            get(`/categoriafotografia/${id}`).then(r => {
                if (r.ok) setState(s => ({ ...s, dados: r.result.data }));
            });
        }
    }, [id]);

    const salvar = async () => {
        const method = id === "criar" ? post : put;
        const url = id === "criar" ? '/categoriafotografia' : `/categoriafotografia/${id}`;
        const response = await method(url, state.dados);
        if (response.ok) {
            Swal.fire({ title: "Categoria salva!", icon: "success", confirmButtonColor: "#587b7f" });
            navigate("/admin/iconografico/categorias");
        } else {
            Swal.fire({ title: "Não foi possível salvar a categoria", icon: "error", confirmButtonColor: "#587b7f" });
        }
    };

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/iconografico/categorias" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Categoria</h2>
                            <p className="admin-subtitle small mb-0">Classificação de alto nível para o acervo</p>
                        </div>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-12">
                                <Form.Label className="label-admin">* Nome da Categoria</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    value={state.dados.nome_categoria} 
                                    onChange={e => setState({...state, dados: {...state.dados, nome_categoria: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>

                            <Form.Group className="col-12">
                                <Form.Label className="label-admin">Descrição / Definição</Form.Label>
                                <Form.Control 
                                    as="textarea" rows={4}
                                    className="input-moderno" 
                                    value={state.dados.descricao} 
                                    onChange={e => setState({...state, dados: {...state.dados, descricao: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvar}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Categoria
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}